<template>
  <transition name="fade" mode="out-in">
    <router-view />
  </transition>
</template>

<script>
export default {
  beforeDestroy() {
    this.$store.dispatch('createPost/reset');
  },
};
</script>
